import "./component-library428.mjs";
import normalizeComponent from "./component-library97.mjs";
const _sfc_main = {
  name: "EnergyLabelIconAWithPlus",
  props: {
    reverse: {
      type: Boolean,
      default: false
    },
    pluses: {
      type: Number,
      default: 1,
      validator: (value) => [1, 2, 3].includes(value)
    },
    color: {
      type: String,
      default: "#50af31"
    }
  }
};
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c;
  return _c("svg", { attrs: { "xmlns": "http://www.w3.org/2000/svg", "viewBox": "0 0 17.75 5.08" } }, [_c("polygon", { staticClass: "cls-1", class: { "cls-1--reverse": _vm.reverse }, style: { fill: _vm.color }, attrs: { "points": "16.04 5.08 0 5.08 0 0 16.04 0 17.75 2.54 16.04 5.08" } }), _c("path", { staticClass: "cls-2", attrs: { "d": "M3.31,3.26l-.22.79H2.36l1-3.1h.92l1,3.1H4.44L4.2,3.26Zm.79-.53-.2-.66c0-.18-.11-.41-.15-.6h0c-.05.19-.09.42-.14.6l-.19.66Z" } }), _c("path", { staticClass: "cls-2", attrs: { "d": "M6.9,1.6v1h1V3h-1v1H6.45V3h-1V2.61h1v-1Z" } }), _vm.pluses > 1 ? _c("path", { staticClass: "cls-2", attrs: { "d": "M9.65,1.6v1h1V3h-1v1H9.2V3h-1V2.61h1v-1Z" } }) : _vm._e(), _vm.pluses > 2 ? _c("path", { staticClass: "cls-2", attrs: { "d": "M12.4,1.6v1h1V3h-1v1H12V3H11V2.61h1v-1Z" } }) : _vm._e()]);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "1a4bdcab",
  null,
  null
);
const EnergyLabelIconAWithPlus = __component__.exports;
export {
  EnergyLabelIconAWithPlus as default
};
